/**
 * 返回安全可遍历的数组
 *
 * @param value 数组
 * @param defaultValue 空数组时的默认值
 */
export function safeArray(value, defaultValue) {
    const safeValue = Array.isArray(value) ? value : [];
    return safeValue.length === 0 && defaultValue ? defaultValue : safeValue;
}
